import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Calendar, ShoppingCart, Headphones } from "lucide-react";
import api from "@/lib/api";
import BookModal from "@/components/BookModal";

const fmt = (d) => {
  if (!d) return "TBA";
  try { return new Date(d + "T00:00:00").toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" }); }
  catch { return d; }
};

export const CurrentRead = () => {
  const [book, setBook] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => { api.get("/books/current").then(({ data }) => setBook(data && data.id ? data : null)); }, []);
  if (!book) return null;

  return (
    <div className="relative bg-mahogany-950 gold-frame rounded-sm overflow-hidden shadow-[0_20px_60px_rgba(0,0,0,0.5)]" data-testid="current-read">
      <div className="grid md:grid-cols-5 gap-0">
        <div className="md:col-span-2 relative p-6 sm:p-8 flex items-center justify-center bg-gradient-to-br from-mahogany-800 to-mahogany-950">
          <button onClick={() => setOpen(true)} className="block" data-testid="current-cover">
            <img src={book.cover_url} alt={book.title} className="w-full max-w-[260px] rounded-sm shadow-[0_15px_40px_rgba(0,0,0,0.6)] transition-transform duration-500 hover:scale-[1.03]" />
          </button>
        </div>
        <div className="md:col-span-3 p-6 sm:p-10">
          <div className="flex items-center gap-3 mb-3">
            <span className="text-[10px] uppercase tracking-[0.2em] bg-fuchsia text-white px-3 py-1 rounded-full font-semibold">Currently Reading</span>
            {book.month && <span className="text-caramel text-xs uppercase tracking-wider">Month {book.month}</span>}
          </div>
          <h3 className="font-serif text-3xl sm:text-4xl text-cream leading-tight mb-1 break-words">{book.title}</h3>
          <p className="text-caramel text-lg mb-2 font-light">by {book.author}</p>
          {book.theme && <p className="font-script text-2xl text-gold mb-4">{book.theme}</p>}
          <p className="text-cream/70 text-sm leading-relaxed mb-6">{book.description}</p>
          {book.reading_deadline && (
            <div className="mb-7 border-y border-gold/15 py-5">
              <p className="flex items-center gap-1.5 text-gold text-[10px] uppercase tracking-wider mb-1"><Calendar size={12} /> Read By</p>
              <p className="text-cream text-base">{fmt(book.reading_deadline)}</p>
            </div>
          )}
          <div className="flex flex-wrap gap-3 mb-4">
            {book.purchase_url && <a href={book.purchase_url} target="_blank" rel="noreferrer" className="btn-primary inline-flex items-center gap-2" data-testid="current-buy"><ShoppingCart size={16} /> Buy the Book</a>}
            {book.audiobook_available && book.audiobook_url && <a href={book.audiobook_url} target="_blank" rel="noreferrer" className="btn-secondary inline-flex items-center gap-2" data-testid="current-audiobook"><Headphones size={16} /> Listen to the Audiobook</a>}
          </div>
          <Link to={`/books/${book.id}/discussion`} className="inline-block text-fuchsia text-sm uppercase tracking-wider hover:text-gold transition-colors" data-testid="join-discussion-btn">Join the Discussion →</Link>
        </div>
      </div>
      <BookModal book={book} open={open} onClose={() => setOpen(false)} />
    </div>
  );
};

export default CurrentRead;
